<!-- 底部通用组件 -->
<template>
    <div class="c-footer">
        <div class="footer-bg">
            <div class="footer-content">
                <p style="margin-bottom: 15px;">邮箱：info@chinalawinfo.com 全国热线： 400-810-8266 传真:86-10-82668268</p>
                <p>版权所有 ：北京北大英华科技有限公司 北京大学法制信息中心 京ICP证010230-17号</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CFooter',
        components: {

        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'footer-demo'
                }
            }
        },
        data() {
            return {
                // 大驼峰命名
                DemoList: []
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {

        },
        destroyed() {

        },
        methods: {
            // 请求方法 动词开头 + 自定义 + data结尾
            getAxiosData() {

            },

            // 其他方法 动词开头 + 自定义
            setLocalStorage() {

            }
        }
    }
</script>

<style scoped>
    .c-footer {
        height: 112px;
    }

    .footer-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: #17181e;
    }

    .footer-content {
        font-size: 14px;
        text-align: center;
        color: #fff;
    }
</style>